import { Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { EAvailableChartPeriod, INITIAL_CHART_PERIOD } from 'src/models/charts.model';

@Component({
  selector: 'liberro-chart-periods-switch',
  standalone: false,
  templateUrl: './liberro-chart-periods-switch.component.html',
  styleUrl: './liberro-chart-periods-switch.component.less'
})
export class LiberroChartPeriodsSwitchComponent {
  @Input() public options: (string | number)[] = [];
  @Input({ required: true }) public value!: string | number;
  @Output() private valueChanged = new EventEmitter<EAvailableChartPeriod>();

  public selectedValue = signal<EAvailableChartPeriod>(INITIAL_CHART_PERIOD);

  public availablePeriods = Object.values(EAvailableChartPeriod).reverse() as EAvailableChartPeriod[];

  public handleValueChange(changedValue: EAvailableChartPeriod): void {
    this.selectedValue.set(changedValue);
    this.valueChanged.emit(changedValue);
  }
}
